import { FormInputError } from 'components/FormInputError/FormInputError';
import { forwardRef } from 'react';
import type { ReactNode } from 'react';

export interface FormFieldProps {
  className?: string;
  children?: ReactNode;
  label?: ReactNode;
  description?: ReactNode;
  error?: string;
  renderError?: (error: string) => ReactNode | string;
  noBottomSpacing?: boolean;
}

/**
 * Component for wrapping form input into standardized field with label & error
 */
export const FormField = forwardRef<HTMLDivElement, FormFieldProps>(
  (props, ref) => (
    <div className={props.className} ref={ref}>
      {props.label && <div className='form__label'>{props.label}</div>}
      {props.description && (
        <div className='form__description'>{props.description}</div>
      )}
      {props.children}
      {(!props.noBottomSpacing || props.error) && (
        <FormInputError error={props.error} renderError={props.renderError} />
      )}
    </div>
  ),
);

FormField.displayName = 'FormField';
